import "intersection-observer";

import React, { useEffect, useRef, useState } from "react";

import css from "./video.module.scss";
import dynamic from "next/dynamic";
import { fireEvent } from "../utils/tracking";
import { isSafari } from "../utils/browser";
import playImg from "../../../static/images/play-btn.svg";

const YouTube = dynamic(() => import("react-youtube"));

const noop = () => {};

function useOnScreen(ref, rootMargin = "0px") {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}
export default function Video({
  glance,
  index,
  onPlay = noop,
  onPause = noop
}) {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [show, SetShow] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);
  useEffect(
    function() {
      if (btnClicked && onScreen) {
        SetShow(true);
      } else if (!onScreen) {
        SetShow(false);
        setBtnClicked(false);
      }
    },
    [onScreen, btnClicked]
  );
  function clickHandler() {
    setBtnClicked(true);
    onPlay();
    fireEvent("Glance", "Play Video", index);
  }
  function onReady(e) {
    e.target.playVideo();
  }
  if (glance.type === "WALLPAPER") {
    return null;
  }
  if (
    !(
      glance.peek.type === "VIDEO" &&
      glance.peek.videoPeek.video.type === "YOUTUBE"
    )
  ) {
    return null;
  }
  const video = glance.peek.videoPeek.video.youtubeVideo;
  const playerVars = isSafari()
    ? {
        autoplay: 1,
        mute: 1,
        playsinline: 1
      }
    : {
        autoplay: 1
      };
  const opts = {
    height: "345",
    width: "420",
    playerVars: playerVars
  };
  return video ? (
    <div className={css["resp-container"]} ref={ref}>
      {show ? (
        <YouTube
          videoId={video.videoId}
          opts={opts}
          onReady={onReady}
          id={"resp-iframe" + video.videoId}
          containerClassName={css["video-player"]}
          onPlay={onPlay}
          onPause={onPause}
        />
      ) : (
        <div className={css["video"]}>
          <div className={css["videoBtn"]} onClick={clickHandler}>
            <img
              src={playImg}
              alt="video thumbnail"
              className={css["width100"]}
            />
          </div>
        </div>
      )}
    </div>
  ) : null;
}
